import React, { Component } from "react";
import { Parallax } from "react-skrollr";
import { multiLanguage } from "../../hoc";
import { Button, BackgroundImage } from "../../components";

@multiLanguage()
export default class TheSanctuaryclub extends Component {
  render() {
    const { t, description, image, title, currentLanguage, page } = this.props;
    console.log("TheSanctuaryclub", { page, image });
    return (
      <div className="section-sanctuaryclub">
        <div className="parallax-container">
          <Parallax
            data={{
              "data-86-bottom-top":
                "transform: translateY(-100px); filter: blur(300px) saturate(2);",
              "data-250-top":
                "transform: translateY(0px); filter: blur(0px) saturate(1);",
            }}
          >
            <BackgroundImage
              image={image}
              style={{ backgroundPositionY: "top" }}
            ></BackgroundImage>
          </Parallax>
        </div>
        <div className="sanctuaryclub-content">
          <Parallax
            data={{
              "data-bottom-top": "transform: translateY(200px); opacity: 0;",
              "data-250-top": "transform: translateY(0px); opacity: 1;",
            }}
          >
            <div className="content">
              <h3>{t(title)}</h3>
              <div dangerouslySetInnerHTML={{ __html: t(description) }} />
              <a
                className="sanctuaryclub-button-text"
                href={`/${currentLanguage}/sanctuary-club`}
              >
                <Button type="default" defaultStyle={{ padding: "2px 50px" }}>
                  {t("View Benefits")}
                </Button>
              </a>
            </div>
          </Parallax>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/common/TheSanctuaryclub.js